import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-akaun-gen-doc-lock-dialog",
  templateUrl: "./akaun-gen-doc-lock-dialog.component.html",
  styleUrls: ["./akaun-gen-doc-lock-dialog.component.scss"],
})
export class AkaunGenDocLockDialogComponent {
  public headerMessage: string;
  public warningMessage: string;
  constructor(public dialogRef: MatDialogRef<AkaunGenDocLockDialogComponent>) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
}
